const header = document.getElementById("header")
const headerBtn = document.getElementById("toggle")
const navOverlay = document.getElementById("navOverlay")
const listItem = document.querySelectorAll(".header__innerNavInList li a")
const listItemArry = [...listItem]

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-open");
})

navOverlay.addEventListener("click", () => {
    header.classList.toggle("is-open");
})

listItemArry.forEach((items) => {
    items.addEventListener("click", () => {
        header.classList.toggle("is-open");
    })
})